import * as React from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import { Stack, Avatar, Grid } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Link } from "react-router-dom";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

function TeamMembers(props) {
  return (
    <div className="team-container">
      <Grid container className="about-us" spacing={2}>
            <Grid item xs={12} key = {props.TeamMembers.employeeCode}>
              <Item className="team-box">
                <div className="team-avtar">
                <Avatar
                  sx={{
                    width: 50,
                    height: 50,
                  }}
                  alt={props.TeamMembers.firstName}
                  src={props.TeamMembers.profilePhotoName ? `/api/uploads/image/show/${props.TeamMembers.profilePhotoName}`:''}
                />
                </div>
                <div className="team-content">
                <Link to={`/users-profile/${props.TeamMembers.id}`} className="team-name">
                  {props.TeamMembers.firstName + " " + props.TeamMembers.lastName}
                </Link>
                <p className="team-email">{props.TeamMembers.emailId}</p>
                <p className="team-email">test@aggregateintelligence.in</p>                
                </div>
              </Item>
            </Grid>
      </Grid>
    </div>
  );
}
export default TeamMembers;
